import axios from 'axios';

import { CSRF_TOKEN } from '../const.js.erb';

const authenticity_token = CSRF_TOKEN;

const transformRequest = [
  data => ({ ...data, authenticity_token }),
  ...axios.defaults.transformRequest
]

const transformResponse = [
  (data) => {
    let resp
    try {
      resp = JSON.parse(data)
    } catch (error) {
      throw Error([`Oops, something went wrong! Sorry, please try again later.`])
    }

    if (resp.success === true) {
      return resp.data
    } else {
      const { errors } = resp || [];
      const message = errors.map( err => err.detail );
      throw Error(JSON.stringify(message));
    }
  }
]

export const axiosPostConfig = {
  transformResponse,
  transformRequest
}
